import { AnalystData, CalendarManager, Ratings, RatingsAnalystsParams } from '@benzinga/calendar-manager';
import { SafePromise } from '@benzinga/safe-await';
import { Session } from '@benzinga/session';
import { injectLogos, injectQuotes } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchAnalystRatings = async (session: Session, params = {}, injectTickersLogos = true): Promise<Ratings[]> => {
  try {
    const calendarManager = session.getManager(CalendarManager);
    const res = await calendarManager.getCalendarData('ratings', {
      fields: '*,ratings_accuracy.smart_score,ratings_accuracy.overall_success_rate,ratings_accuracy.total_ratings',
      pageSize: 100,
      ...params,
    });
    const items: Ratings[] = res.ok && res.ok.length ? res.ok : [];

    if (items.length) {
      const reqs = [injectTickersLogos ? injectLogos(items, session) : null, injectQuotes(items, undefined, session)];
      const result = await Promise.all(reqs);
      return result[1] || items;
    }
    return items;
  } catch (error) {
    logCalendarFetchFailure('analyst-ratings', error);
    return [];
  }
};

const fetchRatingsAnalysts = async (
  session: Session,
  params: RatingsAnalystsParams = {},
): SafePromise<AnalystData | null> => {
  const query = {
    fields: 'id,name_first,name_last,name_full,firm_id,firm_name,ratings_accuracy,updated',
    ...params,
  };
  const calendarManager = session.getManager(CalendarManager);
  return calendarManager.getRatingsAnalysts(query);
};

export { fetchAnalystRatings, fetchRatingsAnalysts };
